var AppOverlayModule = /** @class */ (function () {
    function AppOverlayModule() {
    }
    return AppOverlayModule;
}());
export { AppOverlayModule };
